export default __webpack_public_path__ + "static/media/googlekeep clone.9bbea0ce.png";